import { WishLocalLogoWrapper } from 'styles/common/WishLocalLogo';

type PropsType = {
  color?: string;
  width?: string;
};

const SvgWishLocalLogo = ({ color, width }: PropsType) => {
  const color1 = color || '#545452';
  const color2 = color || '#1E1E1C';
  return (
    <WishLocalLogoWrapper width={width}>
      <svg viewBox="0 0 141 33" width="141">
        <path
          d="M106.419 24.6437H105.099V31.8625H109.555V30.625H106.419V24.6437Z"
          fill={color1}
        />
        <path
          d="M114.422 32.0687C116.553 32.0687 118.045 30.46 118.045 28.2531C118.045 26.0566 116.553 24.4375 114.422 24.4375C112.301 24.4375 110.799 26.0566 110.799 28.2531C110.799 30.46 112.301 32.0687 114.422 32.0687ZM114.422 30.8003C113.042 30.8003 112.179 29.7175 112.179 28.2634C112.179 26.8094 113.032 25.7059 114.422 25.7059C115.813 25.7059 116.675 26.8094 116.675 28.2634C116.675 29.7175 115.813 30.8003 114.422 30.8003Z"
          fill={color1}
        />
        <path
          d="M123.614 32.0687C124.456 32.0687 125.258 31.8316 125.837 31.4087V30.1197C125.349 30.5012 124.619 30.8106 123.807 30.8106C122.223 30.8106 121.239 29.7175 121.239 28.2325C121.239 26.7578 122.223 25.6853 123.797 25.6853C124.669 25.6853 125.329 26.0153 125.816 26.3969V25.0562C125.339 24.7366 124.578 24.4375 123.614 24.4375C121.371 24.4375 119.859 26.0359 119.859 28.2841C119.859 30.3981 121.229 32.0687 123.614 32.0687Z"
          fill={color1}
        />
        <path
          d="M133.862 31.8625L131.517 24.6437H129.721L127.397 31.8625H128.746L129.274 30.1506H131.954L132.481 31.8625H133.862ZM130.604 25.8091L131.619 29.0987H129.589L130.604 25.8091Z"
          fill={color1}
        />
        <path
          d="M137.197 24.6437H135.878V31.8625H140.333V30.625H137.197V24.6437Z"
          fill={color1}
        />
        <path
          d="M70.3454 23.6419C69.9571 19.2312 66.2419 18.4797 62.6143 17.2589C59.3356 16.1551 56.2567 16.0555 55.9248 13.6925C55.5729 11.1845 58.02 9.66574 60.5837 10.1222C63.3642 10.6172 63.8935 12.7697 63.2513 14.1648C64.5343 15.7643 67.7208 15.5877 68.6994 14.4786C69.5064 13.5649 69.7782 12.0545 68.0876 10.6209C66.014 8.86221 61.762 8.02322 57.6934 8.79204C53.6893 9.54653 50.5191 11.899 50.8777 15.8209C51.2638 20.04 54.2484 21.2653 58.9763 22.5358C63.5513 23.7672 65.0517 25.0505 64.7525 27.194C64.4853 29.1059 62.8719 30.673 59.4195 30.2716C55.9672 29.8702 54.1549 27.2084 54.8594 24.2055C50.9304 23.2963 49.2324 27.194 52.5074 29.7684C55.6583 32.2461 61.8459 32.4589 65.3316 31.1181C68.4514 29.9185 70.704 27.7244 70.3454 23.6419Z"
          fill={color2}
        />
        <path
          d="M43.2475 6.95476C45.382 6.95476 47.1127 5.41183 47.1127 3.50901C47.1127 1.60619 45.382 0.0625 43.2475 0.0625C41.113 0.0625 39.3816 1.60543 39.3816 3.50901C39.3816 5.41259 41.1122 6.95476 43.2475 6.95476Z"
          fill={color2}
        />
        <path
          d="M46.2975 8.84033C45.337 9.27069 44.2988 9.49295 43.249 9.49295C42.1993 9.49295 41.1611 9.27069 40.2005 8.84033L40.1931 31.5905H46.302L46.2975 8.84033Z"
          fill={color2}
        />
        <path
          d="M86.6443 8.16044C84.4408 8.16044 82.3582 8.84929 80.7174 10.098V0.746826H74.4526V31.5873H80.6944V17.3003C80.6944 13.672 81.2482 11.9533 83.0635 10.5808C84.7125 9.33443 87.0379 9.55625 88.303 10.4488C89.8332 11.5285 89.7641 14.1073 89.7641 16.1671V31.5904H95.873V16.069C95.873 10.5356 92.1407 8.16044 86.6443 8.16044Z"
          fill={color2}
        />
        <path
          d="M28.8923 31.5904H22.7864L17.9843 17.5162L14.595 31.5904H8.48692L0.839722 8.8418H7.11043L13.586 28.5227C15.9025 21.9254 17.3547 15.7816 15.1051 8.8418H21.2117L28.8923 31.5904Z"
          fill={color2}
        />
        <path
          d="M31.8325 8.12793C30.3891 10.6585 28.83 12.5198 26.7378 14.3804C28.8359 16.6235 30.7537 19.7418 31.8325 22.713C32.9135 19.7418 34.829 16.6235 36.9279 14.3804C34.8342 12.5198 33.275 10.6585 31.8325 8.12793Z"
          fill={color2}
        />
      </svg>
    </WishLocalLogoWrapper>
  );
};

export default SvgWishLocalLogo;
